import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Grid, Box } from "@material-ui/core";
import Radio from "@mui/material/Radio";

const CombinedPreview = React.forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  return (
    <>
      <Dialog
        disableEnforceFocus
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent>
          <Grid item md={12} xs={12} className="test-instructions">
            <div className="btmbdrgry">
              <h3>Preview</h3>
            </div>
            {props?.dataObj?.examType === "Objective" && (
              <Box sx={{ marginTop: "20px" }}>
                {props.dataObj?.questionType && (
                  <Typography component="span">
                    <span>
                      <strong>Type :</strong>
                    </span>{" "}
                    {props.dataObj?.questionType}
                  </Typography>
                )}
                <Typography component="h3">
                  <strong>
                  {props.dataObj?.questionBankSet?.questionBody
                    ? "Q." + " " + props.dataObj?.questionBankSet?.questionBody
                    : ""}
                  </strong>
                </Typography>

                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {props.dataObj?.questionBankSet?.responseChoice?.map(
                    (el, i) => (
                      <li key={i}>
                        {el.responseText && (
                          <>
                            <Radio
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 26,
                                  padding: 0,
                                },
                              }}
                            />
                            <Typography
                              component="span"
                              style={{ marginRight: "5px" }}
                            >
                              {el.responseId + " ."}
                            </Typography>
                          </>
                        )}
                        {el.responseText}
                      </li>
                    )
                  )}
                </ul>
                {props.dataObj?.questionBankSet?.correctResponse && (
                  <Typography component="span">
                    <span>
                      <strong>Correct Answer :</strong>
                    </span>{" "}
                    {props.dataObj?.questionBankSet?.correctResponse}
                  </Typography>
                )}
                <br />
                {props.dataObj?.questionBankSet?.explanations && (
                  <Typography component="span">
                    <span>
                      <strong>Explanation :</strong>
                    </span>{" "}
                    {props.dataObj?.questionBankSet?.explanations}
                  </Typography>
                )}
              </Box>
            )}
            {props?.dataObj?.examType === "Subjective" && (
              <Box>
                {props.dataObj?.questionBankSet?.questionType && (
                  <Typography component="span">
                    <span>
                      <strong>Type :</strong>
                    </span>{" "}
                    {props.dataObj?.questionBankSet?.questionType}
                  </Typography>
                )}
                <Typography component="h3">
                  {props.dataObj?.questionBankSet?.questionBody
                    ? "Q." + " " + props.dataObj?.questionBankSet?.questionBody
                    : ""}
                </Typography>
                <ul style={{ listStyleType: "none", padding: 0 }}>
                  {props.dataObj?.questionBankSet?.responseChoice?.map(
                    (el, i) => (
                      <li key={i}>
                        {el.responseText && (
                          <>
                            <Typography
                              component="span"
                              style={{ marginRight: "5px" }}
                            >
                              {el.responseId + " ."}
                            </Typography>
                          </>
                        )}
                        {el.responseText}
                      </li>
                    )
                  )}
                </ul>
              </Box>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
});

export default CombinedPreview;
